"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BehaviorCodeNotificationMessageType = void 0;
var BehaviorCodeNotificationMessageType;
(function (BehaviorCodeNotificationMessageType) {
    BehaviorCodeNotificationMessageType["EMAIL"] = "email";
    BehaviorCodeNotificationMessageType["POST"] = "post";
})(BehaviorCodeNotificationMessageType || (exports.BehaviorCodeNotificationMessageType = BehaviorCodeNotificationMessageType = {}));
